import { Route } from "react-router-dom";

//CSS
import "../../Pages/0PageStyles.css";
import "./pageLoader.css";
import CrashCover from "./crashCover";
//Functions and hooks
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function PageLoader({ loading, error, children }) {
  const { t } = useTranslation();
  if (loading) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="loading-screen"
      >
        <div className="loadingBackground">
          <div className="spinner"></div>
          <div className="loading-text">
            <h2>{t("Loading")}</h2>
            <div className="dots">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          </div>
        </div>
      </motion.div>
    );
  } else if (error) {
    return <CrashCover error={error} />;
  }

  return children;
}
